import React from 'react';
import PropTypes from 'prop-types'
import { LoadingSpinner } from '../../components';

export default function LoadingControl(props) {
  return (
    <>
      { props.isLoadingPage && <LoadingSpinner /> }
      { !props.isLoadingPage && props.isLoadingPage !== undefined && props.children }
    </>
  );
}

LoadingControl.propTypes = {
  isLoadingPage: PropTypes.bool,
}
